<div echarts [options]="options" class="demo-chart" style="height: 360px"></div>
<!-- <div id="barchart" style="width: 100%; height: 150px"></div>
<div>hello</div> -->
